import { React, useEffect, useState } from "react";
import JobCardCylinderChild from "./JobCardCylinderChild";
import moment from "moment";
import {
  lengthUnit,
  weightUnit,
} from "../../Utils/Constant/MeasurementUnitList";
import { Button, Col, Form, Input, Skeleton, Tooltip } from "antd";
import Iconmoon from "../IconsFiles/icon";
import { Styled } from "../../Pages/pageStyled";
import { EditSetsContainer, CylinderShimmer } from "../../Pages/styledElements";
import {
  cancelSets,
  cylinderReorder,
} from "../../Services/productionPlanningServices";
import { useForm } from "antd/lib/form/Form";

const JobCardCylinder = ({
  cylinderData,
  multiview,
  units,
  isValidState,
  jobId,
  cancelSetToggle,
  deckle_match_page = false,
  combinationNumber,
  solution,
  maxWidth,
  solId = "1",
  maxAvailableWidth,
}) => {
  const [isEditEnabled, setIsEditEnabled] = useState(false);
  const [inputText, setInputText] = useState(parseFloat(cylinderData.count));
  const [errorMsg, setErrorMsg] = useState();
  const [dragId, setDragId] = useState({});
  const [isLoading, setIsloading] = useState(false);
  const [reRender, setRerender] = useState(false);
  const [form] = useForm();
  const handleDrop = (ev) => {
    // console.log(ev);
    if (!isEditEnabled || !cylinderData.allow_reel_rearranging) return;
    const target = JSON.parse(ev.currentTarget.id);
    // console.log(target)
    const dragCylinderIndex = cylinderOrders.findIndex(
      (cylinder) =>
        cylinder.uuid == dragId.uuid &&
        dragId.combinationNumber === cylinder.combinationNumber
    );
    const dropCylinderIndex = cylinderOrders.findIndex(
      (cylinder) =>
        cylinder.uuid == target.uuid &&
        target.combinationNumber === cylinder.combinationNumber
    );
    // console.log(combinationNumber, dropCylinderIndex, dragCylinderIndex, target, dragId)
    if (
      dragCylinderIndex === -1 ||
      dropCylinderIndex === -1 ||
      dragId.combinationNumber != target.combinationNumber
    )
      return;
    let newCylinderOrders = [...cylinderOrders];
    const draggedCylinder = newCylinderOrders.splice(dragCylinderIndex, 1)[0]; // Remove the dragged cylinder
    newCylinderOrders.splice(dropCylinderIndex, 0, draggedCylinder); // Insert the dragged cylinder at the drop position
    newCylinderOrders.map((order, index) => {
      order.left = -23 * index;
      return order;
    });
    setCylinderOrders(newCylinderOrders);
    setDragId({});
  };

  const handleEditSetsToggle = (isCancelled) => {
    setIsEditEnabled(!isEditEnabled);
    setErrorMsg();
    setInputText(parseFloat(cylinderData.count));
    setDragId({});
    isCancelled &&
      setCylinderOrders(
        cylinderData.orders.map((order, index) => {
          return {
            ...order,
            uuid: index,
            combinationNumber: combinationNumber,
          };
        })
      );
    setInputText(cylinderData.count)
    setErrorMsg();
    form.setFieldsValue("cancel-set-input", cylinderData.count)
  };
  const calcWidth = () => {
    let width = 0;
    cylinderData.orders.map((order) => (width += order.width));
    // console.log(width)
    return width;
  };
  const [cylinderOrders, setCylinderOrders] = useState(
    cylinderData.orders.map((order, index) => {
      return { ...order, uuid: index, combinationNumber: combinationNumber };
    })
  );
  const validateInput = (newValue) => {
    const validInputPattern = /^\d+$/;
    if (validInputPattern.test(newValue)) {
      setInputText(newValue);
      setErrorMsg();
    } else {
      setErrorMsg("Enter a positive integer");
    }
  };
  const handleInputChange = (e) => {
    let newValue = e.target.value.trim();
    validateInput(newValue);
  };
  const handleSave = () => {
    // console.log(inputText);
    if (!inputText) {
      setErrorMsg("Please enter an integer");
      return;
    }
    const no_of_cancelled_sets =
      parseFloat(cylinderData.count) - parseFloat(inputText);
    let orderArray = cylinderOrders.map((order, index) => {
      return order.uuid;
    });
    const trimLossIndex = cylinderOrders.findIndex(
      (order, index) => order.item_type === "trim_loss"
    );
    // console.log(cylinderData.orders, orderArray, trimLossIndex)
    let originalTrimLossIndex = cylinderData.orders.findIndex(
      (order, index) => order.item_type === "trim_loss"
    );
    originalTrimLossIndex =
      originalTrimLossIndex === -1 ? orderArray.length : originalTrimLossIndex;
    if (trimLossIndex !== -1) {
      orderArray.splice(trimLossIndex, 1);
    }
    orderArray = orderArray.map((order) => {
      if (order > originalTrimLossIndex) order = order - 1;
      return order;
    });
    let cylinderReorderRequest = {
      jobcard: parseFloat(jobId),
      solution: solution,
      // repeated: cylinderData.actual_count,
      combination: combinationNumber,
      reel: orderArray,
      trim_loss: trimLossIndex,
    };
    const request = {
      jobcard_id: parseFloat(jobId),
      no_of_cancelled_sets,
      parent_reel_ids: cylinderData.parent_reel_ids.splice(
        0,
        no_of_cancelled_sets
      ),
    };
    setIsloading(true);
    cancelSets(request)
      .then((response) => {
        // console.log(response);
        cylinderReorder(cylinderReorderRequest)
          .then((response) => {
            // console.log(response);
            // if (cancelSetToggle) cancelSetToggle();
            setErrorMsg();
            setInputText();
            setIsEditEnabled(false);
            if (cancelSetToggle) cancelSetToggle();
            setIsloading(false);
          })
          .catch((error) => {
            console.log(error.response.data.msg);
            setIsloading(false);
          });
      })
      .catch((error) => {
        setErrorMsg(error.response.data.msg);
        setIsloading(false);
      });
  };
  const widthSize = () => {
    const percentage = deckle_match_page ? 68 : 80;
    const max = maxWidth.max;
    const diff = maxWidth.maxDiff;
    let extraPixels = 0;
    const widthThreshold = window.screen.width / 2.8;
    // console.log(widthThreshold, max - diff);
    if (max - diff > widthThreshold) {
      extraPixels = max - diff - widthThreshold;
    }
    return `calc(${
      maxAvailableWidth - 200 + 23 * (maxWidth.maxReels - 1)
    }px + 100%})`;
  };
  useEffect(() => {
    setRerender(!reRender);
  }, [cylinderOrders, solId]);
  return (
    <>
      <td
        class="ant-pipe-container"
        att={cylinderData.trim_loss}
        style={{
          width: `calc(100% + ${
            (cylinderData.orders.length - 1) * 23 - 210
          }px)`,
          maxWidth: widthSize(),
          // marginRight: '10px'
        }}
      >
        {/* <ReactSortable list={cylinderOrders} setList={handleDragAndDrop} style={{width: '100%'}}> */}
        {cylinderOrders.map((order, index, orders) => (
          // <div key={order.uuid} style={{width: '100%'}}>
          <JobCardCylinderChild
            order={order}
            classname={
              index + 1 === orders.length &&
                order.color !== "white" &&
                index == cylinderOrders.length - 1
                ? // &&
                // cylinderData.trim_loss == 0
                `cylinder-${order.color}-last`
                : `cylinder-${order.color}`
            }
            multiview={multiview}
            units={units}
            trimloss={cylinderData.trim_loss}
            totalWidth={calcWidth()}
            maxWidth={maxWidth.max}
            handleDrag={(ev) => {
              if (!isEditEnabled || !cylinderData.allow_reel_rearranging)
                return;
              // console.log(ev.target.id)
              return setDragId(JSON.parse(ev.currentTarget.id));
            }}
            handleDrop={handleDrop}
            uuid={order.uuid}
            isValidState={isEditEnabled && cylinderData.allow_reel_rearranging}
            isLoading={isLoading}
            reRender={reRender}
            deckleMatchPage={deckle_match_page}
          />
          //  </div>
        ))}
        {/* </ReactSortable> */}
        {/* {console.log(calcWidth())} */}
      </td>
      <span
        class="cylinder-text"
        style={{
          // width: deckle_match_page ? "32%" : "20%",
          width: "190px",
          float: "right",
          paddingLeft: deckle_match_page ? "1px" : "10px",
        }}
      >
        {/* {isLoading ? (
        <>
          <CylinderShimmer>
            <Skeleton
              paragraph={{ rows: 2 }}
              active={true}
              style={{
                width: "100%",
                margin: "0px",
                padding: "0px",
                margin: "0px",
              }}
              size={"small"}
              shape={"default"}
              className="shimmer"
            />
          </CylinderShimmer>
        </>
      ) : ( */}
        <>
          <p>
          Utilized: {
    cylinderData?.orders?.reduce(
      (sum, item) => (sum + (parseFloat(item.order_width) || 0)),
      0
    ).toFixed(3)
  } {units?.order_width || 'cm'}            </p>
          <p>
            Dia: {cylinderData.reel_od ? cylinderData.reel_od : 0}{" "}
            {units?.reel_od ? units.reel_od : "cm"}
            {"/ "}
            {cylinderData.core_id ? cylinderData.core_id : 0}{" "}
            {units?.core_id ? units.core_id : "cm"}
          </p>{" "}
          <p
            style={{
              display: "flex",
              width: "100%",
              paddingRight: "7px",
            }}
          >
            <span style={{ width: "80%", display: "flex", maxWidth: "80px" }}>
              Sets:{" "}
              {!isEditEnabled ? (
                cylinderData.count < 10 && cylinderData.count > 0 ? (
                  "0" + cylinderData.count
                ) : (
                  cylinderData.count
                )
              ) : (
                <EditSetsContainer style={{ width: "60%" }}>
                  <Form form={form}>
                    <Form.Item
                      name="cancel-set-input"
                      initialValue={inputText}
                      style={{
                        margin: "0px",
                        padding: "0px",
                        minHeight: "0px",
                      }}
                    >
                      <Input
                        className="input"
                        size="small"
                          onChange={handleInputChange}
                          disabled={isLoading}
                      />
                    </Form.Item>
                  </Form>
                </EditSetsContainer>
              )}
            </span>
            {isValidState && (
              <EditSetsContainer>
                {!isEditEnabled ? (
                  <div className="edit-container">
                    {cylinderData?.count > 0 && (
                      <Styled>
                        <Tooltip
                          placement="bottom"
                          title={"Edit number of sets"}
                          className="edit-tooltip"
                        >
                          <Button
                            className="btn"
                            onClick={() => handleEditSetsToggle()}
                          >
                            <Iconmoon
                              icon="edit"
                              size={12}
                              style={{
                                opacity: cylinderData?.count ? 1 : 0,
                                transform: "translateX(-5px)",
                              }}
                              color="#8E8583"
                            />
                          </Button>
                        </Tooltip>
                      </Styled>
                    )}
                    {/* </Col> */}
                    {/* <Col span={12}> */}
                    <Styled>
                      <Tooltip
                        placement="bottom"
                        title={`Original Sets: ${cylinderData.actual_count}\nCancelled Sets: ${cylinderData.cancelled_count}`}
                        className="edit-tooltip"
                      >
                        <Button
                          className="btn"
                          // onClick={() => handleEditSetsToggle()}
                          style={{
                            width: cylinderData?.count > 0 ? "" : "100%",
                            marginLeft: cylinderData?.count > 0 ? "" : "10px",
                          }}
                        >
                          <Iconmoon
                            icon="info_new"
                            size={15}
                            color="#8E8583"
                            style={{
                              // opacity: 0.7,
                              marginTop: "2px",
                              float: "right",
                            }}
                          />
                        </Button>
                      </Tooltip>
                    </Styled>
                  </div>
                ) : (
                  <div className="edit-container" style={{width: '40%'}}>
                    {!errorMsg && (
                        <Tooltip placement="bottom" title="Save changes">
                          <Button
                        className="btn"
                        style={{ marginTop: "2px", transform: isLoading &&'translateY(-4px)', background: 'transparent !important', cursor:'pointer' }}
                          onClick={() => handleSave()}
                          loading={isLoading}
                      >
                       {!isLoading && <Iconmoon icon="check" size={14} color="green" />}
                      </Button>
                      </Tooltip>
                    )}
                      {!isLoading &&
                        <Tooltip placement="bottom" title="Discard changes">
                          <Button
                          className="btn"
                          style={{ marginTop: "2px" }}
                          onClick={() => handleEditSetsToggle(true)}
                          loading={isLoading}
                        >
                          <Iconmoon icon="cancel" size={14} color="red" />
                        </Button>
                        </Tooltip>
                      }
                  </div>
                )}
              </EditSetsContainer>
            )}
          </p>
          <p
            // className="error"
            style={{
              color: "red",
              fontSize: "9px",
              margin: "0px",
              padding: "0px",
              transform: "translateY(-7px)",
              lineHeight: 1,
            }}
          >
            {errorMsg}
          </p>
        </>
      </span>
    </>
  );
};

export default JobCardCylinder;
